import { gql } from '@apollo/client';
import { mutate } from '../../../../Services/Gateway/Apollo';

export const RECORD_QUESTION_ANSWER = gql`
  mutation RecordQuestionAnswer(
    $answers: [String]!
    $componentId: Int!
    $isFreeText: Boolean!
    $isUnary: Boolean!
    $lyticsId: String
    $questionId: String!
    $visitorId: String!
    $countryCode: String!
    $hasDynamicNewsletterQuestion: Boolean
    $testMode: Boolean
  ) {
    recordQuestionAnswer(
      answers: $answers
      componentId: $componentId
      isFreeText: $isFreeText
      isUnary: $isUnary
      lyticsId: $lyticsId
      questionId: $questionId
      visitorId: $visitorId
      countryCode: $countryCode
      hasDynamicNewsletterQuestion: $hasDynamicNewsletterQuestion
      testMode: $testMode
    ) {
      status
      message
    }
  }
`;

const recordQuestionAnswerMutation = async (variables) => {
  const response = await mutate({
    mutation: RECORD_QUESTION_ANSWER,
    variables,
  });

  return response.data.status;
};

export default recordQuestionAnswerMutation;
